import React from 'react';
import PropTypes from 'prop-types';
import { Field } from './styles';

import 'react-datepicker/dist/react-datepicker.css';

const TextArea = ({
  disabled, name, onChange, placeholder, value,
}) => (
  <Field
    name={name}
    value={value}
    placeholder={placeholder}
    onChange={onChange}
    disabled={disabled}
  />
);

TextArea.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};

TextArea.defaultProps = {
  disabled: false,
  name: '',
  value: '',
  placeholder: '',
  onChange: () => {},
};

export default TextArea;



// WEBPACK FOOTER //
// ./src/components/TextArea/index.js